$(document).ready(function() {

  insertBundlePrompts();

  $('body').on('ajaxCart.afterCartLoad', function() {
    insertBundlePrompts();
  });
  
});

function insertBundlePrompts() {
  const bundleRows = $('tr.bundle-eligible, .cart-item.bundle-eligible'),
        bundles = {},
        upsellMessages = [
          { qty: 3, discount: "10%" },
          { qty: 5, discount: "15%" },
          { qty: 7, discount: "20%" },
        ];
  if (bundleRows) {
    bundleRows.each(function() {
      
      const productId = $(this).data('product-id');
      const quantity = parseInt($(this).find('.quantity__amount').val(), 10);
  
      if (isNaN(quantity)) {
        return; 
      }

      if (!bundles[productId]) {
        bundles[productId] = 0;
      }
      bundles[productId] += quantity;
  
    });
  
    $.each(bundles, function(productId, quantity) {
      const row = $(`.bundle-eligible[data-product-id="${productId}"]`);
      row.find('.bundle-upsell').html('');
      let message = '';
      
      const closestQuantity = upsellMessages.reduce((acc, curr) => {
        if (curr.qty > quantity && (acc === null || curr.qty < acc)) {
          return curr;
        }
        return acc;
      }, null);
      
      if (closestQuantity === null) {
        console.log('closestQuantity === null');
        
        message = '';
      } else {
        console.log('closestQuantity', closestQuantity);
        const quantityToAdd = closestQuantity.qty - quantity;
        const discountMessage = closestQuantity.discount;
        message = `Add ${quantityToAdd} more to get ${discountMessage} off!`;
      }
      
      row.find('.bundle-upsell').append(message);
    });
  }
}